
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting API errors returned during planned maintenance windows and in response to API errors.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='API errors' subtitle='Guide to troubleshooting API errors' mdxType="Header" />
    <h4 {...{
      "id": "internal_server_error-or-plaid-internal-error"
    }}><strong parentName="h4">{`INTERNAL_SERVER_ERROR`}</strong>{` or `}<strong parentName="h4">{`plaid-internal-error`}</strong></h4>
    <ErrorReference type="API_ERROR" error='INTERNAL_SERVER_ERROR' subtitle="Plaid was unable to process the request" server client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be redirected to the Institution Select pane to retry connecting their Item or a different account.`}</p>
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid received an unsupported response from a financial institution, which frequently corresponds to an `}<a parentName="li" {...{
            "href": "/docs/errors/institution"
          }}>{`institution`}</a>{` error.`}</li>
        <li parentName="ul">{`Plaid is experiencing internal system issues.`}</li>
        <li parentName="ul">{`A product endpoint request was made for an Item at an OAuth-based institution, but the end user did not authorize the Item for the specific product, or has revoked Plaid's access to the product. Note that for some institutions, the end user may need to specifically opt-in during the OAuth flow to share specific details, such as identity data, or account and routing number information, even if they have already opted in to sharing information about a specific account.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Retry the request. If the endpoint supports the use of an idempotency key parameter, ensure you are using one before retrying. If the endpoint is `}<inlineCode parentName="p">{`/transfer/create`}</inlineCode>{`, see `}<a parentName="p" {...{
            "href": "/docs/transfer/creating-transfers/#handling-errors-in-transfer-creation"
          }}>{`Handling errors in transfer creation`}</a>{`.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If the Item is at an OAuth-based institution, prompt the end user to allow Plaid to access identity data and/or account and routing number data. The end user should do this during the Link flow if they were unable to successfully complete the Link flow for the Item, or at their institution's online banking portal if the Item has already been added.`}</p>
      </Checkbox>
      <Checkbox checklistId='INTERNAL_SERVER' mdxType="Checkbox">
        <p>{`Prompt your user to retry connecting their Item in a few hours or the following day.`}</p>
      </Checkbox>
      <Checkbox checklistId='INTERNAL_SERVER_1' mdxType="Checkbox">
        <p>{`Check the status of the institution via the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/activity/status"
          }}>{`Dashboard`}</a>{` or `}<inlineCode parentName="p">{`/institutions/get_by_id`}</inlineCode>{`.`}</p>
      </Checkbox>
      <p>{`If the error persists, please submit a `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`, `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{`, and either `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "planned_maintenance"
    }}><strong parentName="h4">{`PLANNED_MAINTENANCE`}</strong></h4>
    <ErrorReference type='API_ERROR' error='PLANNED_MAINTENANCE' subtitle="Plaid's systems are undergoing maintenance and API operations are disabled" server client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience-1"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be redirected to the Institution Select pane to retry connecting their Item or a different account.`}</p>
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid's systems are under maintenance and API operations are temporarily disabled. Advance notice will be provided when a maintenance window is planned.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PLANNED_MAINTENANCE' mdxType="Checkbox">
        <p>{`Check Plaid's `}<a parentName="p" {...{
            "href": "https://status.plaid.com/"
          }}>{`System status`}</a>{` for any recent maintenance updates.`}</p>
      </Checkbox>
      <p>{`If you have not been previously informed of planned maintenance, please reach out to Plaid `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/"
        }}>{`Support`}</a>{` for more information.`}</p>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "internal_server_error-or-plaid-internal-error",
        level: 4,
        title: <React.Fragment><strong>{`INTERNAL_SERVER_ERROR`}</strong>{` or `}<strong>{`plaid-internal-error`}</strong></React.Fragment>,
      },
{
        id: "planned_maintenance",
        level: 4,
        title: "PLANNED_MAINTENANCE",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
